import api from '@services/api'

export default {
  load(axios, params, payload, config) {
    return api.post(axios, '/utils/config', params, payload, { ...config, isBackground: true })
  },
}
